module.exports = "https://cdn.dove.it/_next/static/public/assets/channels/logo-idealista.55fcea4e6db4ef9706c2791968cace91.png";